// Instance
import MainAPI from "@/app/apis/main/main-api.js";

// Endpoints
import { API, ENDPOINTS } from "@/app/apis/main/_connection/connection-api.js";

// Query String
const queryString = require("querystring");

class puppyPackAPI extends MainAPI {
    /**
     * @return {object} product list
     * @param {*} puppyPackDetails - Contains pagination data
     */
    async getPuppyPacks(puppyPackDetails) {
        return API.get(`${ENDPOINTS.GET_PUPPY_PACK}/list?${queryString.stringify(puppyPackDetails)}`);
    }

    /**
     * Get details of a specific puppy pack.
     *
     * @param {string} puppyPackId - The unique identifier of the puppy pack.
     * @returns {Promise<object>} A promise that resolves to an object representing the puppy pack details.
     */
    async getPuppyPackDetails(puppyPackId) {
        return API.get(`${ENDPOINTS.GET_PUPPY_PACK_DETAILS}?f_puppyPackId=${(puppyPackId)}`);
    }

}

export default new puppyPackAPI();
